<template>
  <div class="container">
    <div class="row">
      <div class="col-12 ps-0 pe-0 ps-lg-5 pe-lg-3 mt-2">
        <div class="d-flex justify-content-center">
          <!-- -->

        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import LoadingBs5 from "@/components/frontend/LoadingBs5";

import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "HomeView",
  created() {
    this.$store.state.TokenAccessToken = window.location.search.replace("?token=", "");
    let TokenCookie = localStorage.getItem("Token");

    if (this.$store.state.TokenAccessToken != "") {
      // console.log("get url");
      localStorage.setItem('Token', this.$store.state.TokenAccessToken);
    }
    else if (TokenCookie != null) {
      // console.log("get local");
      localStorage.setItem('Token', TokenCookie);
    }
    else {
      window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
    }
  },
  async mounted() {
    await this.Test();

    let AccessToken = localStorage.getItem("Token");
    await this.VertifyToken(AccessToken);
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    await this.CheckInActive(AuthorizeToken);

    this.$store.state.CHANGE_POSITION.AGENTCODE = this.$store.state.AgentCode;
  },
  data() {
    return {
      token: "",
      Loading: true
    };
  },
  components: {
    LoadingBs5,
  },
  methods: {
    async Test() {
      const API_PROXY_URL = '/api/AgencyERequest/Geturl'

      try {
        const response = await fetch(API_PROXY_URL, {
          method: 'GET',
          headers: {
            'Accept': '*/*'
          }
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const proxyResult = await response.json();

        console.log('proxyResult=', proxyResult);
      } catch (err) {
        console.error('Proxy API Error:', err)
      }
    },

    async VertifyToken(token) {
      if (token != null) {
        await http.get("AgencyERequest/VertifyToken?", { headers: { Token: token } }).then((response) => {
          if (response.status == 200) {
            localStorage.setItem('AuthorizeToken', response.data);
          }
          else {
            this.Loading = false;
            window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
          }
        }).catch(() => {
          this.Loading = false;
          console.log("Error VertifyToken : ");
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
        });
      }
    },
    async CheckInActive(AuthorizeToken) {
      if (AuthorizeToken != null) {
        await http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
          if (response.status == 200) {
            if (response.data.USER_NAME === null) {
              this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
              this.$store.state.AgentCode = response.data.AGENTCODE;
              this.$store.state.Email = response.data.EMAIL;
              this.$store.state.Mobile_Phone = response.data.MOBILE_PHONE;
              this.Loading = false;

              this.$router.push('/AgenteService');
            } else {
              this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
              this.$store.state.USER_NAME = response.data.USER_NAME;
              this.$store.state.Email = response.data.EMAIL;
              this.$store.state.Mobile_Phone = response.data.MOBILE_PHONE;
              this.Loading = false;

              this.$router.push('/ProspectService');
            }
          }
          else {
            this.Loading = false;
            localStorage.removeItem("Token");
            localStorage.removeItem("AuthorizeToken");
            window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
          }
        }).catch((error) => {
          this.Loading = false;

          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ท่านไม่สามารถเข้าสู่ระบบได้</label>',
            confirmButtonText: 'ตกลง',
            allowOutsideClick: false,// ไม่ให้คลิกนอก popup เพื่อปิด
            allowEscapeKey: false,// ไม่ให้กด Esc เพื่อปิด
          }).then((result) => {
            if (result.isConfirmed) {
              localStorage.removeItem("Token");
              localStorage.removeItem("AuthorizeToken");
              window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
            }
          });

          // Swal.fire({
          //   icon: 'error',
          //   html: '<label class="fs-4 fw-normal font-family">ท่านไม่สามารถเข้าสู่ระบบได้</label>',
          // }).then(() => {
          //   localStorage.removeItem("Token");
          //   localStorage.removeItem("AuthorizeToken");
          //   window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
          // });

        });
      }
    },
    Authentication() {
      // let Token = this.$cookies.get("Token");
      let Token = localStorage.getItem("Token");
      // this.$store.commit('Authentication', Token);

      // this.$router.push('/AgenteService');

      http.get("AgencyERequest/AuthenticationToken?", { headers: { Token: Token, Authorization: `Bearer ${this.$store.state.AccessToken}` } }).then((res) => {
        if (res.status != 200) {
          console.log("Error AuthenticationToken");
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
        }
        else {
          this.$store.state.AgentCode = res.data.AGENTCODE;
          this.$router.push('/AgenteService');
        }
      }).catch(() => {
        console.log("Error AuthenticationToken");
      });
    }
  },
};
</script>
